import { type SVGProps } from 'react'

export function LanguageIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color || '#EAECF0'

  return (
    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.54952 11.008H12.8672M8.54952 11.008L7.39815 13.4154M8.54952 11.008L10.274 7.40228C10.4129 7.11173 10.4824 6.96646 10.5775 6.92055C10.6601 6.88063 10.7565 6.88063 10.8392 6.92055C10.9343 6.96646 11.0037 7.11173 11.1427 7.40228L12.8672 11.008M12.8672 11.008L14.0185 13.4154M1.98148 3.78574H5.59259M5.59259 3.78574H7.69908M5.59259 3.78574V2.58203M7.69908 3.78574H9.20371M7.69908 3.78574C7.40047 5.56558 6.70758 7.17788 5.69223 8.53099M6.7963 9.2024C6.42765 9.03678 6.0516 8.80643 5.69223 8.53099M5.69223 8.53099C4.87821 7.90707 4.14981 7.05177 3.78704 6.19314M5.69223 8.53099C4.72645 9.81806 3.46892 10.8706 1.98148 11.6098"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
